/*
画面・ロールの構成を見直した際は、下記の確認が必要
  ic.gdd_ccdDefss // role ごとの表示色
  iv.gdd_ftrDefss // fole ごとのメニュー構成
  iv.get_iniPageRole // cm10c410 ごとの初期画面と role
  iv.get_iniPageInfs // cm10c410 ごと・画面ごとの role
  iv.get_bwdPageInfs // 画面ごとの呼び出し元画面

 */

/*
import {Dimensions} from 'react-native';

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { cp } from './cp';
import { ip } from './ip';
*/
import { bf } from './bf';

export class iv { // individual view def
    //
    static get_iniPageInfs(p_roleKey) {
        if (p_roleKey == '90') { // 全体管理者の場合
            return {
                sgc_pageRole: 'own1',
                sgc_pageName: 'iCpyList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
                sgcb_pageEdt: false,
            };
        }
        else if (p_roleKey == '20') { // 各社運営者の場合
            return {
                sgc_pageRole: 'adm1',
                sgc_pageName: 'iCpyDtl',
                sgc_pageKey: global.c?.state.sgcd_pagePntKeys.cm20_key,
                sgc_pageMode: 'show',
            };
        }
        else if (p_roleKey == '10') { // 一般利用者の場合
            return {
                sgc_pageRole: 'mmb1',
                sgc_pageName: 'iHome',
                sgc_pageKey: global.c.state.sgc_cm10_key,
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
                sgcb_pageEdt: false,
            };
        }
        else { // その他の場合
            alert('incorrect pageRole at get_iniPageInfs: {}'.f(p_roleKey));
        }
    };

    static _get_hdrPfx = (p_pfx) => {
        let _sfx = '';
        switch (global.c?.state.sgc_pageMode) {
            case 'new':
                _sfx = '新規';
                break;
            case 'edit':
            case 'show':
                switch (global.c?.state.sgc_pageRole) {
                    case 'own1':
                        _sfx = '全体共通';
                        break;
                    case 'own2':
                    case 'adm1':
                        _sfx = global.c?.state.sgcd_pagePntKeys.cm20c310 ?? '';
                        break;
                    case 'mmb2':
                    case 'adm3':
                        _sfx = global.c?.state.sgcd_pagePntKeys.cm30c310 ?? '';
                        break;
                    case 'own3':
                    case 'adm2':
                        _sfx = global.c?.state.sgcd_pagePntKeys.cm10c310 ?? '';
                        break;
                    default:
                        break;
                };
                break;
            default:
                _sfx = '';
                break;
        };
        return (bf.f(_sfx)) ? `{}\n{}`.f(p_pfx, _sfx) : p_pfx
    };
    
  static o_gdd_ftrDefss = () => ({ // ftr のメニュー構成, arrow-right, building, check, close, ellipsis-v, envelope, file-text, gear, pencil, plus, search, send, sign-out, sliders, tasks, th-large, th-list, th, trash, user, users
        mmb1: {
          iHome: {
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'mmb1',
            page:'iHome',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: false,
              iconName: null,
              pfx: null,
              d_pageInfs: null,
              onPrs: null,
            },
          },
          iPrcList: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム2',
            role: 'mmb1',
            page:'iPrcList',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'mmb1',
                sgc_pageName: 'iHome',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iPrcDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム2',
            role: 'mmb1',
            page:'iPrcDtl',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'mmb1',
                sgc_pageName: 'iPrcList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMngList: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'mmb1',
            page:'iMngList',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'mmb1',
                sgc_pageName: 'iHome',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMngDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'mmb1',
            page:'iMngDtl',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'mmb1',
                sgc_pageName: 'iMngList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMngInp: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'mmb1',
            page:'iMngInp',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'mmb1',
                sgc_pageName: 'iMngList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMsgList: {
            type:'iconPfx', 
            iconName: 'send',
            pfx:'メッセージ',
            role: 'mmb1',
            page:'iMsgList',
            d_leftBtns: {
              b_vsb: false,
              iconName: null,
              pfx: null,
              d_pageInfs: null,
              onPrs: null,
            },
          },
          iMsgDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'send',
            pfx:'メッセージ',
            role: 'mmb1',
            page:'iMsgDtl',
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'mmb1',
                sgc_pageName: 'iMsgList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMsgSet: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'send',
            pfx:'メッセージ',
            role: 'mmb1',
            page:'iMsgSet',
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'mmb1',
                sgc_pageName: 'iMsgDtl',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iUserDtl: {
            type:'iconPfx', 
            iconName: 'user',
            pfx:'利用者情報',
            role: 'mmb1',
            page:'iUserDtl',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: false,
              iconName: null,
              pfx: null,
              d_pageInfs: null,
              onPrs: null,
            },
          },
          iOrgList: {
            b_vsb: (bf.myCM_get_len(global.c?.state.sgcdld_cm31sss?.cm31 || []) > 0) ? true : false,
            type:'iconPfx', 
            iconName: 'th',
            pfx:'部門一覧',
            role: 'mmb1',
            page:'iOrgList',
            d_leftBtns: {
              b_vsb: false,
              iconName: null,
              pfx: null,
              d_pageInfs: null,
              onPrs: null,
            },
          },
          iOrgDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'th',
            pfx:'部門情報',
            role: 'mmb1',
            page:'iOrgDtl',
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'mmb1',
                sgc_pageName: 'iOrgList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          logout: {
              type:'iconPfx', 
              iconName: 'sign-out',
              pfx:'ログアウト',
              role: '',
              fnc: 'logout',
          },
        },
        adm1: {
          iOrgList: {
            type:'iconPfx', 
            iconName: 'th',
            pfx:'部門一覧',
            role: 'adm1',
            page:'iOrgList',
            d_leftBtns: {
              b_vsb: false,
              iconName: null,
              pfx: null,
              d_pageInfs: null,
              onPrs: null,
            },
          },
          iOrgDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'send',
            pfx:'部門情報',
            role: 'adm1',
            page:'iOrgDtl',
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'adm1',
                sgc_pageName: 'iOrgList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iUserList: {
            type:'iconPfx', 
            iconName: 'users',
            pfx:'利用者一覧',
            role: 'adm1',
            page:'iUserList',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: false,
              iconName: null,
              pfx: null,
              d_pageInfs: null,
              onPrs: null,
            },
          },
          iUserDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'user',
            pfx:'運営者情報',
            role: 'adm1',
            page:'iUserDtl',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: false,
              iconName: null,
              pfx: null,
              d_pageInfs: null,
              onPrs: null,
            },
          },
          iMsgList: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'send',
            pfx:'メッセージ',
            role: 'adm1',
            page:'iMsgList',
            d_leftBtns: {
              b_vsb: false,
              iconName: null,
              pfx: null,
              d_pageInfs: null,
              onPrs: null,
            },
          },
          iMsgDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'send',
            pfx:'メッセージ',
            role: 'adm1',
            page:'iMsgDtl',
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'adm1',
                sgc_pageName: 'iMsgList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMsgSet: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'send',
            pfx:'メッセージ',
            role: 'adm1',
            page:'iMsgSet',
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'adm1',
                sgc_pageName: 'iMsgDtl',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iCpyDtl: {
            type:'iconPfx', 
            iconName: 'building',
            pfx:'法人情報',
            role: 'adm1',
            page:'iCpyDtl',
            d_leftBtns: {
              b_vsb: false,
              iconName: null,
              pfx: null,
              d_pageInfs: null,
              onPrs: null,
            },
          },
          logout: {
            type:'iconPfx', 
            iconName: 'sign-out',
            pfx:'ログアウト',
            role: '',
            fnc: 'logout',
          },
        },
        adm2: {
          iHome: {
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'adm2',
            page:'iHome',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '利用者一覧',
              d_pageInfs: {
                sgc_pageRole: 'adm1',
                sgc_pageName: 'iUserList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iPrcList: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'adm2',
            page:'iPrcList',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'adm2',
                sgc_pageName: 'iHome',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iPrcDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'adm2',
            page:'iPrcDtl',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'adm2',
                sgc_pageName: 'iPrcList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMngList: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'adm2',
            page:'iMngList',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'adm2',
                sgc_pageName: 'iHome',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMngInp: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'adm2',
            page:'iMngInp',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'adm2',
                sgc_pageName: 'iMngList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMngDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'adm2',
            page:'iMngDtl',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'adm2',
                sgc_pageName: 'iMngList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMsgList: {
            type:'iconPfx', 
            iconName: 'send',
            pfx:'メッセージ',
            role: 'adm2',
            page:'iMsgList',
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '利用者一覧',
              d_pageInfs: {
                sgc_pageRole: 'adm1',
                sgc_pageName: 'iUserList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMsgSet: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'send',
            pfx:'メッセージ',
            role: 'adm2',
            page:'iMsgSet',
            d_leftBtns: {
              b_vsb: false,
              iconName: null,
              pfx: null,
              d_pageInfs: null,
              onPrs: null,
            },
          },
          iMsgDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'send',
            pfx:'メッセージ',
            role: 'adm2',
            page:'iMsgDtl',
            d_leftBtns: {
              b_vsb: false,
              iconName: null,
              pfx: null,
              d_pageInfs: null,
              onPrs: null,
            },
          },
          iUserDtl: {
            type:'iconPfx', 
            iconName: 'user',
            pfx:'利用者情報',
            role: 'adm2',
            page:'iUserDtl',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '利用者一覧',
              d_pageInfs: {
                sgc_pageRole: 'adm1',
                sgc_pageName: 'iUserList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iOrgList: {
            type:'iconPfx', 
            iconName: 'th',
            pfx:'部門一覧',
            role: 'adm2',
            page:'iOrgList',
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '利用者一覧',
              d_pageInfs: {
                sgc_pageRole: 'adm1',
                sgc_pageName: 'iUserList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iOrgDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'th',
            pfx:'部門情報',
            role: 'adm2',
            page:'iOrgDtl',
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'adm2',
                sgc_pageName: 'iOrgList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
        },
        own1: {
          iCpyList: {
            type:'iconPfx', 
            iconName: 'building',
            pfx:'法人一覧',
            role: 'own1',
            page:'iCpyList',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: false,
              iconName: null,
              pfx: null,
              d_pageInfs: null,
              onPrs: null,
            },
          },
          iCpyDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'building',
            pfx:'法人情報',
            role: 'own1',
            page:'iCpyDtl',
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '法人一覧',
              d_pageInfs: {
                sgc_pageRole: 'own1',
                sgc_pageName: 'iCpyList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          logout: {
            type:'iconPfx', 
            iconName: 'sign-out',
            pfx:'ログアウト',
            role: '',
            fnc: 'logout',
          },
        },
        own2: {
          iOrgList: {
            type:'iconPfx', 
            iconName: 'th',
            pfx:'部門一覧',
            role: 'own2',
            page:'iOrgList',
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '法人一覧',
              d_pageInfs: {
                sgc_pageRole: 'own1',
                sgc_pageName: 'iCpyList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iOrgDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'send',
            pfx:'部門情報',
            role: 'own2',
            page:'iOrgDtl',
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'own2',
                sgc_pageName: 'iOrgList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iUserList: {
            type:'iconPfx', 
            iconName: 'users',
            pfx:'利用者一覧',
            role: 'own2',
            page:'iUserList',
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '法人一覧',
              d_pageInfs: {
                sgc_pageRole: 'own1',
                sgc_pageName: 'iCpyList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iUserDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'user',
            pfx:'利用者情報',
            role: 'own2',
            page:'iUserDtl',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '利用者一覧',
              d_pageInfs: {
                sgc_pageRole: 'own2',
                sgc_pageName: 'iUserList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iCpyDtl: {
            type:'iconPfx', 
            iconName: 'building',
            pfx:'法人情報',
            role: 'own2',
            page:'iCpyDtl',
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '法人一覧',
              d_pageInfs: {
                sgc_pageRole: 'own1',
                sgc_pageName: 'iCpyList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
        },
        own3: {
          iHome: {
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'own3',
            page:'iHome',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '利用者一覧',
              d_pageInfs: {
                sgc_pageRole: 'own2',
                sgc_pageName: 'iUserList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iPrcList: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'own3',
            page:'iPrcList',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'own3',
                sgc_pageName: 'iHome',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iPrcDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'own3',
            page:'iPrcDtl',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'own3',
                sgc_pageName: 'iPrcList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMngList: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'own3',
            page:'iMngList',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'own3',
                sgc_pageName: 'iHome',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMngInp: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'own3',
            page:'iMngInp',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'own3',
                sgc_pageName: 'iMngList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMngDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'own3',
            page:'iMngDtl',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'own3',
                sgc_pageName: 'iMngList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMsgDtl: {
            type:'iconPfx', 
            iconName: 'send',
            pfx:'メッセージ',
            role: 'own3',
            page:'iMsgDtl',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '利用者一覧',
              d_pageInfs: {
                sgc_pageRole: 'own2',
                sgc_pageName: 'iUserList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iUserDtl: {
            type:'iconPfx', 
            iconName: 'user',
            pfx:'利用者情報',
            role: 'own3',
            page:'iUserDtl',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '利用者一覧',
              d_pageInfs: {
                sgc_pageRole: 'own2',
                sgc_pageName: 'iUserList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },

          iOrgList: {
            type:'iconPfx', 
            iconName: 'th',
            pfx:'部門一覧',
            role: 'own3',
            page:'iOrgList',
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '利用者一覧',
              d_pageInfs: {
                sgc_pageRole: 'own2',
                sgc_pageName: 'iUserList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iOrgDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'th',
            pfx:'部門情報',
            role: 'own3',
            page:'iOrgDtl',
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'own3',
                sgc_pageName: 'iOrgList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },

        }, 
/*
        own4: {
          iHome: {
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'own4',
            page:'iHome',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '部門一覧',
              d_pageInfs: {
                sgc_pageRole: 'own2',
                sgc_pageName: 'iOrgList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iPrcList: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム2',
            role: 'own4',
            page:'iPrcList',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'own4',
                sgc_pageName: 'iHome',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iPrcDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム2',
            role: 'own4',
            page:'iPrcDtl',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'own4',
                sgc_pageName: 'iPrcList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMngList: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'own4',
            page:'iMngList',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'own4',
                sgc_pageName: 'iHome',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMngDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'own4',
            page:'iMngDtl',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'own4',
                sgc_pageName: 'iMngList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iMngInp: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'home',
            pfx:'ホーム',
            role: 'own4',
            page:'iMngInp',
            sgcd_pagePntKeys: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'own4',
                sgc_pageName: 'iMngList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
          iOrgDtl: {
            type:'iconPfx', 
            iconName: 'th',
            pfx:'部門情報',
            role: 'own4',
            page:'iOrgDtl',
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '部門一覧',
              d_pageInfs: {
                sgc_pageRole: 'own2',
                sgc_pageName: 'iOrgList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
              },
              onPrs: null,
            },
          },
        },
*/
  });

  static _get_leftBtns = (p_pageRole, p_pageName, p_pageMode) => { // p_pageName は未使用
    let _r = {};
    let _pageType = (p_pageName?.substr(-4) == 'List') ? 'list' : 'dtl'; // gdd_ftrDefss において定義されていない pageName を考慮
//bf.l('1286: {}, {}, {}, {}'.f(p_pageRole, p_pageName, p_pageMode, _pageType))
    switch (_pageType) {
      case 'list':
        switch (p_pageMode) {
          case 'show':
            if (bf.f(iv.o_gdd_ftrDefss()[p_pageRole][p_pageName]) && 
              bf.f(iv.o_gdd_ftrDefss()[p_pageRole][p_pageName].d_leftBtns)) {
              _r = iv.o_gdd_ftrDefss()[p_pageRole][p_pageName].d_leftBtns;
            }
            else {
              _r = {
                b_vsb: false,
                iconName: null,
                pfx: null,
                d_pageInfs: null,
                onPrs: null,
              };
            };
          default:
            break;
        };
        break;
      case 'dtl':
        switch (p_pageMode) {
          case 'new':
          case 'edit':
            _r = {
              b_vsb: true,
              iconName: null,
              pfx: null,
              d_pageInfs: null,
              onPrs: null,
            };
            break;
          case 'show':
            if (
              bf.f(iv.o_gdd_ftrDefss()[p_pageRole][p_pageName]) && 
              bf.f(iv.o_gdd_ftrDefss()[p_pageRole][p_pageName].d_leftBtns)
            ) {
              _r = iv.o_gdd_ftrDefss()[p_pageRole][p_pageName].d_leftBtns;
            }
            else {
              _r = {
                b_vsb: false,
                iconName: null,
                pfx: null,
                d_pageInfs: null,
                onPrs: null,
              };
            };
          default:
            break;
        };
        break;
      default:
        break;
    };
    //
    return _r;
  };

    static gd_stgs = {
        cLgn: { // ログイン画面に関わる設定
            f_ini: () => {
            },
            b_alwNewUser: false, // ログイン画面において新規登録を使用
            b_usePcy: false, // 新規利用者登録において利用規約を使用
        },
        cCtgDtl: {
            f_ini: () => {
                global.c?.setState({ sgcd_hdrs: bf.p(global.c?.state.sgcd_hdrs, _next => {
                    //
                    _next.pfx = iv._get_hdrPfx('分類一覧');
                    _next.d_leftBtns = iv._get_leftBtns(global.c?.state.sgc_pageRole, global.c?.state.sgc_pageName, global.c?.state.sgc_pageMode);
                }),
                }, () => {
                });
            },
        },
/*
        cMsgDtl: {
            f_ini: () => {
                global.c?.setState({
                    sgcd_hdrs: bf.p(global.c?.state.sgcd_hdrs, _next => {
                        //
                        _next.pfx = iv._get_hdrPfx('メッセージ');
                        _next.d_leftBtns = iv._get_leftBtns(global.c?.state.sgc_pageRole, global.c?.state.sgc_pageName, global.c?.state.sgc_pageMode);
                    }),
                }, () => {
                });
            },
        },
        cMsgList: {
            f_ini: () => {
                global.c?.setState({
                    //
                    sgcd_hdrs: bf.p(global.c?.state.sgcd_hdrs, _next => {
                        //
                        _next.pfx = iv._get_hdrPfx('メッセージグループ一覧');
                        _next.d_leftBtns = iv._get_leftBtns(global.c?.state.sgc_pageRole, global.c?.state.sgc_pageName, global.c?.state.sgc_pageMode);
                    }),
                    sgcd_bdys: bf.p(global.c?.state.sgcd_bdys, _next => {
                        _next.ld_defss = [
                            {
                                type: 'List',
                                pfx: '',
                                state: 'sdd_ct21ss',
                                nextRole: global.c?.state.sgc_pageRole,
                                nextPage: 'cMsgDtl',
                                b_edt: false,
                                b_img: false,
                                b_bdr: false,
                            },
                        ];
                    }),
                });
            },
        },
        cMsgSet: {
            f_ini: () => {
                global.c?.setState({
                    sgcd_hdrs: bf.p(global.c?.state.sgcd_hdrs, _next => {
                        //
                        _next.pfx = iv._get_hdrPfx('メッセージグループ');
                        _next.d_leftBtns = iv._get_leftBtns(global.c?.state.sgc_pageRole, global.c?.state.sgc_pageName, global.c?.state.sgc_pageMode);
                    }),
                }, () => {
                });
            },
        },
*/
    };
}
